import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  authenticated: undefined,
  userInfo: null,
  menu: [],
  loading: false,
  error: null,
  success: false,
};

const authSlice = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    login: (state) => {
      state.authenticated = true;
    },
    logout: (state) => {
      state.authenticated = false;
      state.userInfo = null;
      state.menu = [];
    },
    setUserInfo: (state, action) => {
      state.userInfo = action.payload;
    },
    setMenu: (state, action) => {
      state.menu = action.payload;
    }
  }
});

export const { 
  login,
  logout,
  setUserInfo, 
  setMenu, 
} = authSlice.actions;

export default authSlice.reducer;
